import PropTypes from 'prop-types';
import CertificationBadge from './CertificationBadge';

const defaultProps = {};

const propTypes = {
  uri: PropTypes.string.isRequired,
  badge: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
};

export default function BadgeColumn({
  uri,
  badge,
  title,
  color,
}) {
  return (
    <div className="text-center flex justify-center w-full">
      <div className="relative z-10 pt-5 lg:pt-8">
        <CertificationBadge badge={badge} url={uri} title={title} />
      </div>
      <div className="absolute w-full left-0 right-0 h-28 z-0">
        <div className="absolute inset-0 rounded-t-xl" style={{ backgroundColor: color }} />
        <div className="absolute inset-0 rounded-t-xl bg-gradient-to-tr from-gray-900 to-transparent opacity-20" />
      </div>
    </div>
  );
}

BadgeColumn.defaultProps = defaultProps;
BadgeColumn.propTypes = propTypes;
